//
// Javascript for the FormMessages control
// which should appear on any page that contains a form
//
//  Ben Ramey
//  October 2009
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.FormMessages = function (messagesWrapper)
{
  this.parentFormId = messagesWrapper.parents("div.form").attr("id");

  this.infoBox = $("div.ui-state-highlight", messagesWrapper);
  this.errorBox = $("div.ui-state-error", messagesWrapper);

  this.infoMessages = [];
  this.errorMessages = [];

  this.handleInitialMessages(this.infoBox, 10000);
  this.handleInitialMessages(this.errorBox, -1);

  this.setupEvents();
};

HEIJS.Controls.FormMessages.prototype =
{
  //
  // Properties
  //
  infoBox: null,
  errorBox: null,
  infoMessages: null,
  errorMessages: null,
  parentFormId: null,

  //
  // Methods
  //
  addInfoMessage: function (message)
  {
    this.infoMessages.push(message);
  },

  addErrorMessage: function (message)
  {
    this.errorMessages.push(message);
  },

  clearInfoMessages: function ()
  {
    this.infoMessages = [];
  },

  clearErrorMessages: function ()
  {
    this.errorMessages = [];
  },

  showAllInfoMessages: function (summaryMessage, delay, floatCss)
  {
    this.showAllMessages(this.infoBox, summaryMessage, this.infoMessages, delay || 5000, floatCss);
  },

  showAllErrorMessages: function (summaryMessage, delay, floatCss)
  {
    this.showAllMessages(this.errorBox, summaryMessage || "The form has errors:", this.errorMessages, delay || -1, floatCss);
  },

  showAllMessages: function (box, summaryMessage, messages, delay, floatCss)
  {
    if (summaryMessage)
    {
      box.children("p").show().children("span").html(summaryMessage).addClass('form-messages-msg');
    }
    else
    {
      box.children("p").hide();
    }

    box.children("ul").find("li").remove();
    for (var idx = 0; idx < messages.length; idx++)
    {
      box.children("ul").append("<li>" + messages[idx] + "</li>");
    }

    box.children("ul").show();
    this.showBox(box, delay, null, floatCss);
  },

  // clean out other info messages and only show the new one
  showInfoMessage: function (message, delay, floatCss)
  {
    this.showSingleMessage(this.infoBox, message, delay || 5000, null, floatCss);
  },

  // clean out other error messages and only show the new one
  showErrorMessage: function (message, delay, floatCss)
  {
    this.showSingleMessage(this.errorBox, message, delay || -1, null, floatCss);
  },

  showSingleMessage: function (box, message, delay, showImmediately, floatCss)
  {
    box.children("ul").hide();
    box.children("p").show().children("span:not(.ui-icon)").html(message).addClass('form-messages-msg');

    this.showBox(box, delay, showImmediately, floatCss);
  },

  showBox: function (box, delay, showImmediately, floatCss)
  {
    var domElement = box[0];
    showImmediately = showImmediately || false;
	floatCss = floatCss || false;
	
    if (!domElement)
      return;

    if (domElement._timer > 0
        || box.css("display") !== "none")
    {
      // if the message box is already displaying
      // we will append the new message below, so we
      // want to clear the timer so it doesn't fade too
      // soon after the new message arrives.
      clearTimeout(domElement._timer);
    }
	
	// float the div in the top right of the screen!
	if (floatCss) {
		box.css({ 'position':'fixed' });
		box.css(floatCss);
		box.find('span.ui-icon').first().css({ 'margin-right':'10px'});
		box.find('span:not(.ui-icon)').first().css({ 'float':'left', 'max-width':'270px'});
		box.find('ul').first().css({ 'float':'left' });
	}

    if (showImmediately)
      box.show(0, this.resizeForm);
    else
      box.slideDown("fast", this.resizeForm);

    // a delay > 0 means this message will disappear
    // after a certain a mount of time even if it is not
    // clicked on
    if (delay > 0)
    {
      var callback = this.resizeForm;
      domElement._timer = setTimeout(function () { box.fadeOut("slow", callback); }, delay);
    }
  },

  hideAllMessages: function ()
  {
    this.infoBox.hide('fast');
    this.errorBox.hide('fast', this.resizeForm);

    clearTimeout(this.infoBox[0]._timer);
    clearTimeout(this.errorBox[0]._timer);
  },

  hideInfoMessages: function ()
  {
    if (this.infoBox.is(":visible"))
      this.infoBox.fadeOut("fast", this.resizeForm);
    else
      this.infoBox.hide("fast", this.resizeForm);

    clearTimeout(this.infoBox[0]._timer);
  },

  hideErrorMessages: function ()
  {
    if (this.errorBox.is(":visible"))
      this.errorBox.fadeOut("fast", function () { });
    else
      this.errorBox.hide("fast");

    clearTimeout(this.errorBox[0]._timer);
  },

  resizeForm: function ()
  {
    HEIJS.page.form.resizeForms();
  },

  handleInitialMessages: function (box, hideDelay)
  {
    var messageItems = box.children("ul").children("li");

    // if message(s) exist(s)
    if (messageItems.length > 0)
    {
      if (messageItems.length == 1)
      {
        box.children("ul").hide();
        box.children("p").show();
        this.showBox(box, hideDelay, true);
      }
      else
      {
        box.children("ul").show();
        box.children("p").show();
        this.showBox(box, hideDelay, true);
      }
    }
    else
    {
      box.hide();
    }
  },

  setupEvents: function ()
  {
    var self = this;

    this.infoBox.click(function (e) { self.hideInfoMessages(); });
    this.errorBox.click(function (e) { self.hideErrorMessages(); });
  }
};

$(document).ready(
  function ()
  {
    var formMessageWrappers = $("div.form-messages");
    if (formMessageWrappers.length == 0)
    {
      return;
    }

	HEIJS.page.formMessages = new HEIJS.Controls.FormMessages(formMessageWrappers);
    HEIJS.page.formMessages.multiple = true;

    formMessageWrappers.each(function ()
    {
      var id = $(this).parents("div.form").attr("id");
      var parent = $(this).parent();
      while (!id && parent.length > 0)
      {
        id = parent.attr("id");
        parent = parent.parent();
      }
	  if (!id) id = 'undefined';
      HEIJS.page.formMessages[id] = new HEIJS.Controls.FormMessages($(this));
    });

    HEIJS.page.formMessages.getHandler = function (containerID) {
      var handler = this[containerID] || null;

      if (!handler && !!this.parentFormId && !!containerID && this.parentFormId == containerID) {
        handler = this;
      }
      
      return handler;
    };
  }
);